var FansMdl = angular.module( 'Fans', [ 'Shared', 'Hues', 'FansFilters', 'ui.router', 'FansPartials'] );
